
import { Col, Container, Row } from "react-bootstrap";
// New package button
import { Button } from '@veeyaainnovatives/button';
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

import useCustom from "../hooks/useCustom";

import InputGroup from 'react-bootstrap/InputGroup';

import { Link } from "react-router-dom";

import Form from 'react-bootstrap/Form';
import parse from 'html-react-parser';
import Badge from 'react-bootstrap/Badge';
import { useParams } from "react-router-dom";
import placeholderImage from '../assets/images/placholder.png';


const BlogView = () => {

  const { slug } = useParams();
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const {
    fetchIndividualBlog,
    individualBlog,
    formatDate,
    loading
  } = useCustom();

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchIndividualBlog(slug);
  }, [slug])
  return (
    <div className="body-wrap overflow-hidden">

      {loading && (
        <section className="loading-screen">
          <div className="loader-wrapper">
            <div className="spinner"></div>
            <h4 className="loading-text">Loading ...</h4>
          </div>
        </section>
      )}

      {/* No Blog Found */}
      {!loading && !individualBlog?.blog && (
        <section className="py-5 text-center">
          <h4>Blog not found.</h4>
        </section>
      )}

      {/* Blog Content */}
      {!loading && individualBlog?.blog && (
        <section className='py-4'>
          <div className="position-relative">
            <div className="design-circle-our-worksection position-absolute"></div>

            <Container>
              <h1 className="blog-view-title text-center my-4">
                {individualBlog.blog.title}
              </h1>

              <p className="our-work-desc text-center pb-md-5 pb-4">
                {formatDate(individualBlog.blog.updated_at)}
              </p>

              <div className="studen-work-card mb-5">

                {/* Image */}
                <div className='img-1 mb-5'>
                  <div
                    style={{ backgroundImage: `url(${individualBlog.blog.image})` }}
                    className="main-blog-img img-1"
                  />
                </div>

                <Row>
                  <Col lg={8}>
                    <p className="blog-card-desc overflow-auto mt-2">
                      {individualBlog.blog.excerpt}
                    </p>

                    {/* Parse HTML safely */}
                    <p className="blog-content mt-2">
                      {parse(individualBlog.blog.content || "")}
                    </p>
                  </Col>

                  {/* Right Sidebar */}
                  <Col lg={4}>

                    {/* Search */}
                    <div className="blog-side-card">
                      <h2 className="search-label">Search</h2>
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();

                          if (searchTerm.trim() !== "") {
                            navigate(`/blogs?search=${encodeURIComponent(searchTerm)}`);
                          } else {
                            navigate("/blogs");
                          }
                        }}
                      >
                        <InputGroup className="my-3" size="sm">
                          <Form.Control
                            placeholder="Blog Search ..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />

                          <Button
                            type="submit"
                            className="btn-search"
                            backgroundColor="#677a58"
                            color="#ffffff"
                            hoverBackgroundColor="#5a6a4a"
                            width="75px"
                            height="57px"
                            borderRadius="0px 100px 100px 0px"
                            padding="0"
                            icon="fa-solid fa-magnifying-glass"
                          />
                        </InputGroup>
                      </Form>
                    </div>

                    {/* Related Blogs */}
                    <div className="blog-side-card mt-3">
                      <h2 className="search-label">Related Blogs</h2>

                      {(individualBlog.related_blogs || []).map((relatedBlog, index) => {
                        const relatedBlogImage = relatedBlog?.image && relatedBlog.image.trim() !== '' 
                          ? relatedBlog.image 
                          : placeholderImage;
                        
                        return (
                        <Row className="my-3" key={index}>
                          <Col xs={4}>
                            <img
                              src={relatedBlogImage}
                              className="related-blog-img"
                              alt="blog-img"
                              onError={(e) => {
                                e.target.src = placeholderImage;
                              }}
                            />
                          </Col>

                          <Col xs={8} className="d-flex align-items-center">
                            <div className="related-blog-wrap">
                              <Link to={`/blog-view/${relatedBlog.slug}`}>
                                <h3 className="related-blogs-title theme-color-green">
                                  {relatedBlog.title}
                                </h3>
                                <p className="related-blogs-date text-muted mb-0">
                                  {formatDate(relatedBlog.updated_at)}
                                </p>
                              </Link>
                            </div>
                          </Col>
                        </Row>
                        );
                      })}
                    </div>

                    {/* Tags */}
                    <div className="blog-side-card mt-3">
                      <h2 className="search-label">Blog Tags</h2>

                      <div className="my-3 blog-tags">
                        {(individualBlog.blog.tags || "")
                          .split(",")
                          .map((tag, index) => (
                            <Badge pill bg="primary" key={index} className="me-2">
                              {tag}
                            </Badge>
                          ))}
                      </div>
                    </div>

                  </Col>
                </Row>

              </div>
            </Container>
          </div>
        </section>
      )}

    </div>
  );

}

export default BlogView;